export default __webpack_public_path__ + "static/servicio-aereo-2a522140f62a51f01cfcb3714744bb73.svg";